import { Country, PeriodTag } from '@prisma/client';
import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IUpdateFileStaticTagsParams {
  fileId: number;
  country?: Country | null;
  jurisdiction?: string | null;
  fiscalYearTag?: number | null;
  periodTagType?: PeriodTag | null;
  periodTagValue?: number | null;
}

export async function updateFileStaticTags(
  params: IUpdateFileStaticTagsParams,
): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file/static-tags', {
    method: 'POST',
    body: params,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to update file properties',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
